import { render, staticRenderFns } from "./BaseProperty.vue?vue&type=template&id=4c2e9b28&functional=true&"
import script from "./BaseProperty.vue?vue&type=script&lang=ts&"
export * from "./BaseProperty.vue?vue&type=script&lang=ts&"
import style0 from "./BaseProperty.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports